import React, { useMemo, useState } from 'react';
import { node } from 'prop-types';

import { PopUpStockAmend } from '@screens/StockBuySell/StockAmend';
import { PopUpStockWithdraw } from '@screens/StockBuySell/StockWithdraw';

import PopUpAutoOrderExpired from './PopUpAutoOrderExpired';

export const AutoOrderActionContext = React.createContext();

const AutoOrderActionProvider = ({ children }) => {
  const [popup, setPopup] = useState({ open: '', data: null });

  const contextValue = useMemo(() => ({ popup, setPopup }), [popup, setPopup]);

  return (
    <AutoOrderActionContext.Provider value={contextValue}>
      {children}
      <PopUpStockAmend
        show={popup.open === 'AMEND'}
        data={popup.data}
        onHide={() => setPopup({ open: '', data: null })}
      />
      <PopUpStockWithdraw
        show={popup.open === 'WITHDRAW'}
        data={popup.data}
        onHide={() => setPopup({ open: '', data: null })}
      />
      <PopUpAutoOrderExpired
        show={popup.open === 'REACTIVATE_EXPIRED'}
        onHide={() => setPopup({ open: '', data: null })}
        onConfirm={() => setPopup({ open: 'AMEND', data: popup.data })}
      />
    </AutoOrderActionContext.Provider>
  );
};

AutoOrderActionProvider.propTypes = {
  children: node,
};

AutoOrderActionProvider.defaultProps = {
  children: null,
};

export default AutoOrderActionProvider;
